import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, pages, total, limit, onPage }) {
  if (!total) return null;
  const from = (page - 1) * limit + 1;
  const to = Math.min(page * limit, total);
  const go = (p) => onPage(Math.max(1, Math.min(pages, p)));

  // compact window of page numbers around current
  const nums = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(pages, start + 4);
  for (let i = Math.max(1, end - 4); i <= end; i++) nums.push(i);

  return (
    <div className="flex items-center justify-between gap-3 mt-4 flex-wrap" data-testid="pagination">
      <span className="text-xs text-zinc-500 font-mono" data-testid="pagination-info">
        {from}–{to} of {total}
      </span>
      <div className="flex items-center gap-1">
        <button data-testid="pagination-prev" onClick={() => go(page - 1)} disabled={page <= 1}
          className="flex items-center gap-1 px-2.5 py-1.5 text-xs font-medium border border-zinc-300 rounded-lg hover:border-klein hover:text-klein disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          <ChevronLeft className="h-3.5 w-3.5" /> Prev
        </button>
        {nums.map((n) => (
          <button key={n} data-testid={`pagination-page-${n}`} onClick={() => go(n)}
            className={`min-w-[32px] px-2 py-1.5 text-xs font-bold rounded-lg border transition-colors ${
              n === page ? "bg-klein text-white border-klein" : "border-zinc-300 hover:border-klein hover:text-klein"}`}>
            {n}
          </button>
        ))}
        <button data-testid="pagination-next" onClick={() => go(page + 1)} disabled={page >= pages}
          className="flex items-center gap-1 px-2.5 py-1.5 text-xs font-medium border border-zinc-300 rounded-lg hover:border-klein hover:text-klein disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          Next <ChevronRight className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
